<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生清單</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>學習記錄表</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                查詢時間：
                <select v-model="search.year">
                  <option v-for="item in yearList" :key="item" :value="item">{{item - 1911}}</option>
                </select>
                <select v-model="search.month">
                  <option v-for="item in 12" :key="item" :value="item">{{item}}</option>
                </select>
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div class="col-md-12">
        <div class="panel-body">
          <div align="left">
            小計時數 (依查詢條件變動) : {{totalHour}} 小時 (預設只呈現當月份資料)
          </div><br>

          <table class="table table-no-more table-bordered table-striped mb-none">
            <thead>
              <tr>
                <th class="text-center" width="3%">筆數</th>
                <th class="text-center" width="6%">單位</th>
                <th class="text-center" width="4%">姓名</th>
                <th class="text-center" width="4%">學號</th>
                <th class="text-center" width="4%">學習日期</th>
                <th class="text-center" width="4%">時間(起)</th>
                <th class="text-center" width="4%">時間(迄)</th>
                <th class="text-center" width="3%">學習時數</th>
                <th class="text-center" width="18%">工作項目</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td data-title="筆數" class="text-center">{{index + 1}}</td>
                <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                <td data-title="工讀生姓名" class="text-center">{{item.studentName}}</td>
                <td data-title="學號" class="text-center">{{item.studentId}}</td>
                <td data-title="學習日期" class="text-center">{{item.workDate}}</td>
                <td data-title="時間(起)" class="text-center">{{item.workStartTime}}</td>
                <td data-title="時間(迄)" class="text-center">{{item.workEndTime}}</td>
                <td data-title="學習時數" class="text-center">
                  {{item.workTotalHour}}
                  <span v-if="item.leaveTotalHour!=''" style="color:red;">(-{{item.leaveTotalHour}})</span>
                </td>
                <td data-title="工作項目" class="text-left">{{item.workContent}}</td>
              </tr>
            </tbody>
          </table>

          <div style="border: 1px solid #ddd; margin: 5px 0; padding: 3px 10px;">
            <div style="color: red;">服務心得</div>
            <div v-if="serviceFeedback">{{serviceFeedback}}</div>
            <div v-else style="color: #999;">--尚未填寫--</div>
          </div>

          <div align="left" v-if="ratingItem">
            <font color="#00008B">學習單位考核評量(已考核)</font><br>
            本月該生服務學習成效 : <span>{{ratingItem.result == 1 ? '優良' : ratingItem.result == 2 ? '佳' : '不佳'}} {{ratingItem.resultContent}}</span>
            <div>{{ratingItem.isApproved ? '【核給助學金6,000元】' : '【不核給助學金】'}}</div>
            <div>
              出席情形 {{ratingItem.rating1}}分　　學習態度 {{ratingItem.rating2}}分
              <br>
              專業應用 {{ratingItem.rating3}}分　　口語表達 {{ratingItem.rating4}}分
              <br>
              總分 {{ratingItem.rating1 + ratingItem.rating2 + ratingItem.rating3 + ratingItem.rating4}}分
            </div>
          </div>
          <div align="left" v-else-if="!checkRecord">
            <font color="red">《學習紀錄》與《服務心得》尚未填寫完成</font>
          </div>
          <div align="left" v-else-if="!recordOpen">
            <font color="red">學習單位考核評量-尚未開放填寫</font>
          </div>
          <div align="left" v-else>
            <font color="#00008B">學習單位考核評量(僅每個月最後一天跳出此表格，讓單位/系所填寫，並審核)</font><br>
            本月該生服務學習成效 :
            <div>
              <label><input type="checkbox" name="result" value="1" @change="resultChange"> 優良</label>　　<label><input type="checkbox" name="result" value="2" @change="resultChange"> 佳</label>　　<label><input type="checkbox" name="result" value="3" @change="resultChange"> 不佳</label>　<input type="text" v-show="form.result==3" v-model="form.resultContent">
            </div>
            <div>
              <label><input type="checkbox" name="isApproved" value="1" @change="isApprovedChange"> 核給助學金6,000元</label>　　<label><input type="checkbox" name="isApproved" value="0" @change="isApprovedChange"> 不核給助學金</label>
            </div>
            <div>
              出席情形 <input type="number" min="0" max="30" value="0" @change="ratingChagne(1, $event)">分，該項目最高30分　　學習態度 <input type="number" min="0" max="30" value="0" @change="ratingChagne(2, $event)">分，該項目最高30分
              <br>
              專業應用 <input type="number" min="0" max="20" value="0" @change="ratingChagne(3, $event)">分，該項目最高20分　　口語表達 <input type="number" min="0" max="20" value="0" @change="ratingChagne(4, $event)">分，該項目最高20分
              <br>
              總分 {{totalRating}}分　　(該總分系統自行加總，無須填寫)
            </div>
          </div>
          <br>

          <div align="left">
            <font color="#00008B">生活助學金服務學習服務表說明</font><br/>
            1.每週學習時數8小時為上限，每月不超過30小時，學習成效佳者發給助學金6,000元。<br/>
            2.每學期需參與2次學務處辦理之生活服務學習講座，得列計服務時數，惟每學期以4小時為限，辦理時間於生輔組網頁公告，未參與者取消下學期申請資格。<br/>
            3.學生與學習單位排定服務學習時間，並依時報到，如需請假須先告知學習單位，並擇期補作，未依規定完成服務或考核不佳者取消資格，另由其他申請者遞補。<br/>
          </div>

          <!-- <br> 備註 : 開發後請刪除
          <br> 1「服務學習事項」及[學習單位考核評量」二個區域，於每個月的最後一天產生，讓聘用單位進行審核。且須於每個月5號前，須進行審核。
          <br> 2 產生此表後，須發一封通知信，給聘用單位，提醒審核此學習紀錄表。文字「待給」。
          <br> 3 學習時數表，依每月排班表產生。 -->

          <div class="row datatables-footer">
            <div class="col-sm-12">
              <div class="dataTables_paginate" align="center">
                <tr>
                  <td align="center">
                    <a href="#" @click.prevent="$router.go(-1)" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">返回</a>
                  </td>
                  <td align="center" v-if="ratingItem==null&&checkRecord&&recordOpen"><a href="#" @click.prevent="submit" class="btn-upload btn" style="background-color:#8C0044; border-color:#8C0044; color:#FFF;">儲存考核評量</a></td>
                </tr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      yearList: [],
      maxYear: null,
      maxMonth: null,
      list: [],
      checkRecord: false,
      recordOpen: false,
      ratingItem: null,
      serviceFeedback: null,
      search: {
        year: null,
        month: null
      },
      form: {
        workstudyYear: 0,
        workstudyMonth: 0,
        result: null,
        resultContent: "",
        isApproved: null,
        rating1: 0,
        rating2: 0,
        rating3: 0,
        rating4: 0
      },
      totalHour:0,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    yearMonth() {
      return this.$route.query.ym;
    },
    totalRating() {
      let rating1 = 0,
        rating2 = 0,
        rating3 = 0,
        rating4 = 0;
      if (this.form.rating1) rating1 = this.form.rating1;
      if (this.form.rating2) rating2 = this.form.rating2;
      if (this.form.rating3) rating3 = this.form.rating3;
      if (this.form.rating4) rating4 = this.form.rating4;
      return rating1 + rating2 + rating3 + rating4;
    }
  },
  mounted() {
    let d = this.nowDate();
    let nowY = d.getFullYear();
    for (let i = nowY; i >= 2019; i--) {
      this.yearList.push(i);
    }
    this.maxYear = nowY;
    this.search.year = nowY;
    this.form.workstudyYear = nowY;
    let nowM = d.getMonth() + 1;
    let nowD = d.getDate();
    this.maxMonth = nowM;
    this.search.month = nowM;
    this.form.workstudyMonth = nowM;
    if (this.yearMonth) {
      let ym = this.yearMonth.split("/");
      if (ym.length == 2) {
        this.search.year = parseInt(ym[0]) + 1911;
        this.form.workstudyYear = parseInt(ym[0]) + 1911;
        this.search.month = parseInt(ym[1]);
        this.form.workstudyMonth = parseInt(ym[1]);
      }
    }
    this.load();
  },
  methods: {
    load() {
      this.$http
        .get("/api/workstudy/workstudy-record", {
          params: {
            id: this.id,
            year: this.search.year,
            month: this.search.month
          }
        })
        .then(a => {
          this.list = a.body;
          if (this.list.length > 0) {
            this.list.forEach(item => {
              this.totalHour += parseInt(item.workTotalHour);
            });
            this.checkRecord = this.list.every(item => {
              return item.workContent;
            });
          }
          this.$http
            .get("/api/workstudy/serviceFeedback", {
              params: {
                id: this.id,
                year: this.search.year,
                month: this.search.month
              }
            })
            .then(a => {
              this.serviceFeedback = a.body;
              if (!this.serviceFeedback) {
                this.checkRecord = false;
              }
            });
          this.$http
            .get("/api/workstudy/study-record-rating", {
              params: {
                id: this.id,
                year: this.search.year,
                month: this.search.month
              }
            })
            .then(a => {
              if (a.body == "") this.ratingItem = null;
              else this.ratingItem = a.body;
            });
          this.$http
            .get("/api/workstudy/recordOpen", {
              params: {
                year: this.search.year,
                month: this.search.month
              }
            })
            .then(a => {
              this.recordOpen = a.body;
            });
        });
    },
    searchSubmit() {
      this.form.workstudyYear = parseInt(this.search.year);
      this.form.workstudyMonth = parseInt(this.search.month);
      this.load();
    },
    resultChange(e) {
      let v = parseInt($(e.target).val());
      if (this.form.result == v) {
        $("input[type=checkbox][name=result]").prop("checked", false);
        this.form.result = null;
      } else {
        $("input[type=checkbox][name=result]")
          .not($(e.target))
          .prop("checked", false);
        this.form.result = v;
      }
    },
    isApprovedChange(e) {
      let v = $(e.target).val() === "1";
      if (this.form.isApproved == v) {
        $("input[type=checkbox][name=isApproved]").prop("checked", false);
        this.form.isApproved = null;
      } else {
        $("input[type=checkbox][name=isApproved]")
          .not($(e.target))
          .prop("checked", false);
        this.form.isApproved = v;
      }
    },
    ratingChagne(type, e) {
      let obj = $(e.target);
      let v = obj.val();
      if (!$.isNumeric(v)) {
        this.setRatingVal(type, 0);
        obj.val(0);
        return;
      }
      let iv = parseInt(v);
      let min = parseInt(obj.prop("min"));
      if (iv < min) {
        this.setRatingVal(type, min);
        obj.val(min);
        return;
      }
      let max = parseInt(obj.prop("max"));
      if (iv > max) {
        this.setRatingVal(type, max);
        obj.val(max);
        return;
      }
      this.setRatingVal(type, iv);
    },
    setRatingVal(type, v) {
      switch (type) {
        case 1:
          this.form.rating1 = v;
          break;
        case 2:
          this.form.rating2 = v;
          break;
        case 3:
          this.form.rating3 = v;
          break;
        case 4:
          this.form.rating4 = v;
          break;
      }
    },
    submit() {
      if (this.checkForm() == false) return;
      let checkMsg = "";
      if (
        this.form.rating1 == 0 &&
        this.form.rating2 == 0 &&
        this.form.rating3 == 0 &&
        this.form.rating4 == 0
      )
        checkMsg = "服務學習成效評分皆為0\r\n請問";
      if (!confirm(checkMsg + "是否確認送出學習考核評量資料？")) return false;
      this.$http
        .post("/api/workstudy/study-record-rating/" + this.id, this.form)
        .then(a => {
          if (a.body.status) {
            alert("儲存成功");
            this.$router.push("/workstudy");
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    checkForm() {
      if (this.form.result == null || this.form.isApproved == null) {
        alert("『服務學習成效』 尚未勾選");
        return false;
      }
      if (this.form.result == 3 && !this.form.resultContent.trim()) {
        alert("『服務學習成效不佳原因』 尚未填寫");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>
